<template>
  <p>
    <textarea
      :id="`${name}_${attribute}`"
      v-model="contentValue"
      :rows="rows"
      :placeholder="placeholder"
      :name="`${name}[${attribute}]`"
      :required="required"
      class="form-control"
      @input="updatePreview($event.target.value)"
    >
    </textarea>
  </p>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'MarkdownTextArea',
  props: {
    content: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    rows: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false
    }
  },
  emits: ['updatePreview'],
  data () {
    return {
      contentValue: this.content
    }
  },
  methods: {
    // 1文字入力するたびにAPIリクエストを投げると負荷が大きいため、1秒間入力がない場合にプレビュー更新の処理を実行
    updatePreview: _.debounce(function (textInput) {
      this.$emit('updatePreview', textInput)
    }, 1000)
  }
}
</script>
